import type { IService } from '../../types';
import * as m from '@/paraglide/messages.js';
import TelemedicineIcon from '@/assets/icons/telemedicine-white.svg';
import TelemedicineBanner from '@/assets/banners/telemedicine-card.jpg';
import CommunityIcon from '@/assets/icons/peer-white.svg';
import CommunityBanner from '@/assets/banners/wellbeing-peer-community-platform.jpg';
import HealthNavIcon from '@/assets/icons/platform-white.svg';
import HealthNavBanner from '@/assets/banners/health-navigation-platform.jpg';
import TravelLegalIcon from '@/assets/icons/legal-support-white.svg';
import TravelLegalBanner from '@/assets/banners/travel-legal-advice.jpg';
import TelemedicineNavIcon from '@/assets/icons/telemedicine.svg';
import PeerNavIcon from '@/assets/icons/peer-purple.svg';
import HealthNavNavIcon from '@/assets/icons/platform-purple.svg';
import LegalNavIcon from '@/assets/icons/legal-support-purple.svg';

export const getServices = (): IService[] => [
  {
    name: m.service_telemedicine_name(),
    href: '/services/telemedicine',
    navIcon: TelemedicineNavIcon,
    dashboardIcon: TelemedicineIcon,
    dashboardBanner: TelemedicineBanner,
    description: m.service_telemedicine_description(),
    ariaLabel: m.service_telemedicine_aria(),
    landingBrandName: 'Telus Health',
    landingTagline: m.service_telemedicine_landing_tagline(),
    landingTitle: m.service_telemedicine_landing_title(),
    landingFeatures: [],
    landingLearnMoreLabel: m.service_telemedicine_landing_btn(),
  },
  {
    name: m.service_peer_support_name(),
    href: '/services/peerSupportCommunity',
    navIcon: PeerNavIcon,
    dashboardIcon: CommunityIcon,
    dashboardBanner: CommunityBanner,
    description: m.service_peer_support_description(),
    ariaLabel: m.service_peer_support_aria(),
    landingBrandName: 'Peer Support',
    landingTagline: m.service_peer_support_landing_tagline(),
    landingTitle: m.service_peer_support_landing_title(),
    landingFeatures: [],
    landingLearnMoreLabel: m.service_peer_support_landing_btn(),
  },
  {
    name: m.service_health_nav_name(),
    href: '/services/healthcareNavigation',
    navIcon: HealthNavNavIcon,
    dashboardIcon: HealthNavIcon,
    dashboardBanner: HealthNavBanner,
    description: m.service_health_nav_description(),
    ariaLabel: m.service_health_nav_aria(),
    landingBrandName: 'Novus Health',
    landingTagline: m.service_health_nav_landing_tagline(),
    landingTitle: m.service_health_nav_landing_title(),
    landingFeatures: [],
    landingLearnMoreLabel: m.service_health_nav_landing_btn(),
  },
  {
    name: m.service_legal_travel_name(),
    href: '/services/legalTravelAssistance',
    navIcon: LegalNavIcon,
    dashboardIcon: TravelLegalIcon,
    dashboardBanner: TravelLegalBanner,
    description: m.service_legal_travel_description(),
    ariaLabel: m.service_legal_travel_aria(),
    landingBrandName: 'Legal Travel Assistance',
    landingTagline: m.service_legal_travel_landing_tagline(),
    landingTitle: m.service_legal_travel_landing_title(),
    landingFeatures: [],
    landingLearnMoreLabel: m.service_legal_travel_landing_btn(),
  },
];
